<template>
  <div>
    <b-button @click="goToOverviewPage" lg="4" class="pb-2" variant="info" size="sm">Terug naar overzicht</b-button>
  </div>
</template>

<script>
export default {
  name: "BackButton",
  props: {
    job: Object
  },
  methods: {
    goToOverviewPage() {
      let overViewUrlSegment = this.$store.state.miscData.OverviewPageURL;
      window.location.href =  overViewUrlSegment + window.location.search;
    },
  }
};
</script>